/* GENERATED by scripts/gen-data.mjs — chapter "guardrails" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_GUARDRAILS: NodeDef = {
  "id": "guardrails",
  "tagKey": "path:guardrails.tag",
  "x": 1160,
  "y": 300,
  "w": 220,
  "h": 116,
  "titleKey": "path:guardrails.title",
  "subKey": "path:guardrails.sub",
  "blocks": [
    {
      "id": "guardrails.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:guardrails.b1.title",
      "bodyKey": "path:guardrails.b1.body",
      "flowKey": "path:guardrails.b1.flow",
      "read": [
        "guard"
      ]
    },
    {
      "id": "guardrails.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:guardrails.b2.title",
      "film": "f-guard"
    },
    {
      "id": "guardrails.b3o",
      "kind": "options",
      "xp": 20,
      "titleKey": "path:guardrails.b3o.title",
      "opts": {
        "list": [
          {
            "nKey": "path:guardrails.b3o.opts.0.n",
            "wKey": "path:guardrails.b3o.opts.0.w",
            "uKey": "path:guardrails.b3o.opts.0.u",
            "cKey": "path:guardrails.b3o.opts.0.c",
            "slug": "instruction-in-the-prompt"
          },
          {
            "nKey": "path:guardrails.b3o.opts.1.n",
            "wKey": "path:guardrails.b3o.opts.1.w",
            "uKey": "path:guardrails.b3o.opts.1.u",
            "cKey": "path:guardrails.b3o.opts.1.c",
            "slug": "output-classifier"
          },
          {
            "nKey": "path:guardrails.b3o.opts.2.n",
            "wKey": "path:guardrails.b3o.opts.2.w",
            "uKey": "path:guardrails.b3o.opts.2.u",
            "cKey": "path:guardrails.b3o.opts.2.c",
            "slug": "deterministic-guard"
          },
          {
            "nKey": "path:guardrails.b3o.opts.3.n",
            "wKey": "path:guardrails.b3o.opts.3.w",
            "uKey": "path:guardrails.b3o.opts.3.u",
            "cKey": "path:guardrails.b3o.opts.3.c",
            "slug": "calibrated-threshold"
          },
          {
            "nKey": "path:guardrails.b3o.opts.4.n",
            "wKey": "path:guardrails.b3o.opts.4.w",
            "uKey": "path:guardrails.b3o.opts.4.u",
            "cKey": "path:guardrails.b3o.opts.4.c",
            "slug": "policy-engine"
          },
          {
            "nKey": "path:guardrails.b3o.opts.5.n",
            "wKey": "path:guardrails.b3o.opts.5.w",
            "uKey": "path:guardrails.b3o.opts.5.u",
            "cKey": "path:guardrails.b3o.opts.5.c",
            "slug": "human-in-the-loop"
          }
        ],
        "ref": "guard"
      }
    },
    {
      "id": "guardrails.b3",
      "kind": "tree",
      "xp": 20,
      "titleKey": "path:guardrails.b3.title",
      "tree": {
        "qKey": "path:guardrails.b3.tree.q",
        "branches": [
          {
            "tone": "stop",
            "aKey": "path:guardrails.b3.tree.b.0.a",
            "verdictKey": "path:guardrails.b3.tree.b.0.verdict"
          },
          {
            "tone": "stop",
            "aKey": "path:guardrails.b3.tree.b.1.a",
            "verdictKey": "path:guardrails.b3.tree.b.1.verdict"
          },
          {
            "tone": "warn",
            "aKey": "path:guardrails.b3.tree.b.2.a",
            "then": {
              "qKey": "path:guardrails.b3.tree.b.2.then.q",
              "branches": [
                {
                  "tone": "pass",
                  "aKey": "path:guardrails.b3.tree.b.2.then.b.0.a",
                  "verdictKey": "path:guardrails.b3.tree.b.2.then.b.0.verdict"
                },
                {
                  "tone": "pass",
                  "aKey": "path:guardrails.b3.tree.b.2.then.b.1.a",
                  "verdictKey": "path:guardrails.b3.tree.b.2.then.b.1.verdict"
                }
              ]
            }
          }
        ]
      }
    },
    {
      "id": "guardrails.b4",
      "kind": "check",
      "xp": 45,
      "titleKey": "path:guardrails.b4.title",
      "ex": {
        "type": "classify",
        "binsKey": "path:guardrails.b4.ex.bins",
        "binCount": 2,
        "items": [
          {
            "tKey": "path:guardrails.b4.ex.items.0.t",
            "bin": 0,
            "whyKey": "path:guardrails.b4.ex.items.0.why"
          },
          {
            "tKey": "path:guardrails.b4.ex.items.1.t",
            "bin": 1,
            "whyKey": "path:guardrails.b4.ex.items.1.why"
          },
          {
            "tKey": "path:guardrails.b4.ex.items.2.t",
            "bin": 0,
            "whyKey": "path:guardrails.b4.ex.items.2.why"
          },
          {
            "tKey": "path:guardrails.b4.ex.items.3.t",
            "bin": 1,
            "whyKey": "path:guardrails.b4.ex.items.3.why"
          }
        ]
      }
    }
  ]
};
